import axios from 'axios';

// Create axios instance
const axiosInstance = axios.create();

// Add request interceptor to include token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle 401 errors globally
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // If 401 Unauthorized and not already on login page, redirect to login
    if (error.response?.status === 401 && !window.location.pathname.includes('/login')) {
      console.warn('Unauthorized request detected, but NOT redirecting - let component handle it');
      // Don't auto-redirect, let the component decide what to do
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
